<template>
  <div align="Left">
    <div style="display: flex;justify-content: end;align-items: center;margin-top: -.5rem;">
      <div class="md-layout-item md-size-40" style="padding-left: 0;">
        <md-field>
          <label for="currentType">Type</label>
          <md-select v-model="currentType" name="currentType">
            <md-option v-for="type in masterLookups" :key="type.Name" :value="type.Name">
              {{ type.DisplayValue }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <md-card id="organizations" align="Left" style="margin-top: 0;">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <i class="material-icons">key</i>
        </div>
        <h4 class="title">Master Data</h4>
        <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-right" 
        style="justify-content: end;min-height: 3rem;">
          <div>
            <md-button class="md-icon-button md-primary" @click="handleAdd()" v-if="!isLoading">
              <md-icon>add</md-icon>
              <md-tooltip md-direction="bottom">Add new lookup</md-tooltip>
            </md-button>
          </div>
        </div>

      </md-card-header>

      <md-card-content style="padding-top: 0px" v-if="!isLoading">
        <md-table
          :value="tableData"
          class="table-shopping table-striped table-hover"
          @click.native="labelSort($event, false)"
          style="margin-bottom: 1rem"
        >
          <md-table-row>
            <md-table-empty-state
              :md-description="`No Lookup found for this category`"
              md-label="No Lookup found"
            />
          </md-table-row>
          <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
            <md-table-cell md-label="Name">{{ item.Name || '-' }}</md-table-cell>
            <md-table-cell md-label="Value">{{ item.Value || '-' }}</md-table-cell>
            <md-table-cell md-label="Display Value">{{ item.DisplayValue || '-' }}</md-table-cell>
            <md-table-cell>
              <div style="display: flex;justify-content: end;">
                <md-button class="md-icon-button"
                  style="width: 36px; height:27px;display: flex;align-items: center;justify-content: center;"
                  @click.stop="handleEdit(item)">
                  <md-icon>edit</md-icon>
                  <md-tooltip md-direction="bottom">Edit lookup</md-tooltip>
                </md-button>
                <md-button class="md-icon-button md-danger"
                  style="width: 36px; height:27px;display: flex;align-items: center;justify-content: center;margin-left: 0.5rem;"
                  @click.stop="handleRemove(item)">
                  <md-icon>delete</md-icon>
                  <md-tooltip md-direction="bottom">Remove lookup</md-tooltip>
                </md-button>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>

        <div style="display: flex; align-items: center">
          <div class="table table-stats" style="display: flex; justify-content: center; align-items: start; flex: 2">
            <div class="text-right">
              <p class="card-category">
                Showing from
                <b
                  ><u>{{ startTable }}</u></b
                >
                to
                <b
                  ><u>{{ endTable }}</u></b
                >. Total of
                <b
                  ><u>{{ totalItems }}</u></b
                >
                lookups.
              </p>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>

    <md-dialog :md-active.sync="showFormModal">
      <md-dialog-title style="background-color: rgb(11, 108, 141);color: #fff;margin-bottom: 0;padding: 1rem 24px;">
        {{ itemSelected ? 'Update Lookup' : 'Create Lookup' }} - {{getMasterValueByName(currentType)}}
      </md-dialog-title>
      <md-dialog-content style="margin-top: .5rem;padding: 0 24px;">
        <div>
          <md-field :class="[
              { 'md-valid': !errors.has('name') && touched.name },
              { 'md-form-group': false },
              { 'md-error': errors.has('name') && touched.name }
            ]">
            <label>Lookup Name</label>
            <md-input v-validate="'required|max:45'" type="text" name="name" data-vv-name="name" v-model="name"></md-input>
            <slide-y-down-transition>
              <md-icon v-show="errors.has('name')" class="error">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon v-show="!errors.has('name') && touched.name" class="success">done</md-icon>
            </slide-y-down-transition>
          </md-field>

          <md-field :class="[
              { 'md-valid': !errors.has('value') && touched.value },
              { 'md-form-group': false },
              { 'md-error': errors.has('value') && touched.value }
            ]">
            <label>Display Name</label>
            <md-input v-validate="'required|max:45'" type="text" name="value" data-vv-name="value" v-model="value"></md-input>
            <slide-y-down-transition>
              <md-icon v-show="errors.has('value')" class="error">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon v-show="!errors.has('value') && touched.value" class="success">done</md-icon>
            </slide-y-down-transition>
          </md-field>

          <md-field :class="[
              { 'md-valid': !errors.has('displayValue') && touched.displayValue },
              { 'md-form-group': false },
              { 'md-error': errors.has('displayValue') && touched.displayValue }
            ]">
            <label>Display Value</label>
            <md-input v-validate="'required|max:45'" type="text" name="displayValue" data-vv-name="displayValue" v-model="displayValue"></md-input>
            <slide-y-down-transition>
              <md-icon v-show="errors.has('displayValue')" class="error">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon v-show="!errors.has('displayValue') && touched.displayValue" class="success">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </div>
      </md-dialog-content>
      <md-dialog-actions style="justify-content: center;margin-bottom: 1rem;padding: 0;">
        <md-button :disabled="isSaving" style="width: 100px;background-color: white !important;box-shadow: none;color: #000 !important;" @click="closeFormModal()">Cancel</md-button>
        <md-button class="md-primary" :disabled="isSaving" style="width: 100px;" @click="handleSave()"><span :class="[{'saving': isSaving}]">{{ isSaving ? 'Saving...' : 'Save' }}</span></md-button>
      </md-dialog-actions>
    </md-dialog>

    <loader :is-visible="isLoading" />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex"
import { Modal } from "@/components"
import loader from "@/components/GlobeChek/loader.vue"
import { SlideYDownTransition } from "vue2-transitions"

export default {
  components: {
    loader,
    Modal,
    SlideYDownTransition
  },
  data() {
    return {
      tableData: [],
      masterLookups: [],
      currentType: null,
      totalItems: 0,
      isLoading: false,
      itemSelected: {
        LookupId: 0,
        LookupMasterId: 0,
        Name: "",
        Value: "",
        DisplayValue: ""
      },
      offset: 0,
      limit: 100,

      // form attributes lookup
      name: '',
      value: '',
      displayValue: '',
      touched: {
        name: '',
        value: '',
        displayValue: '',
      },
      isSaving: false,
      showFormModal: false,
    }
  },
  computed: {
    ...mapGetters('masterData', ['lookupMasterData', 'lookupData', 'getMasterIdByName', 'getMasterValueByName']),
    startTable() {
      return this.totalOrganizations === 0 ? 0 : this.offset + 1
    },
    endTable() {
      return Math.min(this.offset + this.limit, this.totalItems)
    }
  },
  watch: {
    currentType(newName) {
      this.getTableData(newName)
    }
  },
  async mounted() {
    await this.getMasterData();
    await this.getTableData();
  },
  methods: {
    ...mapActions('masterData', ['fetchLookupMasterData', 'fetchLookupData',  'updateLookup', 'createLookup', 'deleteLookup']),
    closeFormModal() {
      this.itemSelected = null;
      this.showFormModal = false;
    },
    markTouched(fields = []) {
      fields.forEach(f => { this.touched[f] = true });
    },
    resetTouched(fields = []) {
      fields.forEach(f => { this.touched[f] = false });
    },
    getMasterData: async function () {
      try {
        this.isLoading = true;
        await this.fetchLookupMasterData();
        this.masterLookups = this.lookupMasterData;
        if (!this.currentType) {
          this.currentType = this.masterLookups[0].Name;
        }
      } catch(error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    getTableData: async function () {
      try {
        this.isLoading = true;
        await this.fetchLookupData(this.currentType);
        this.tableData = this.lookupData;
        this.totalItems = this.tableData.length;
      } catch(error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async handleSave() {
      this.markTouched(['name', 'value', 'displayValue']);
      const valid = await this.$validator.validateAll();
      if (!valid) return;
      try {
        this.isSaving = true;
        const isEdit = !!this.itemSelected;
        if (isEdit) {
          const params = {
            id: this.itemSelected.LookupId,
            data: {
              "Name": this.name,
              "DisplayValue": this.displayValue,
              "Value": this.value
            }
          }
          await this.updateLookup(params);
        } else {
          const id = this.getMasterIdByName(this.currentType);
          const params = {
            masterName: this.currentType,
            data: {
              "lookupMasterId": id,
              "name": this.name,
              "displayValue": this.displayValue,
              "value": this.value
            }
          }
          await this.createLookup(params);
        }
        await Swal.fire({
          title: "Success",
          text: ``,
          type: "success",
          confirmButtonClass: "md-button md-success btn-fill",
          buttonsStyling: false
        })
      } catch (e) {
        console.error(e);
        await Swal.fire({
          title: 'Error',
          text: 'Try again later',
          confirmButtonClass: 'md-button md-danger btn-fill',
          buttonsStyling: false
        });
      } finally {
        this.resetTouched(['name', 'value', 'displayValue']);
        this.closeFormModal();
        this.isSaving = false;
        await this.getTableData();
      }
    },
    handleAdd() {
      this.itemSelected = null;
      this.name = null;
      this.value = null;
      this.displayValue = null;
      this.showFormModal = true;
    },
    handleEdit(item) {
      this.itemSelected = item;
      this.name = item.Name;
      this.value = item.Value;
      this.displayValue = item.DisplayValue;
      this.showFormModal = true;
    },
    async handleRemove(item) {
      this.itemSelected = item;
      const response = await Swal.fire({
        title: "Confirmation",
        text: "Do you want to delete this lookup?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      })
      if (response.value) {
        try {
          this.isLoading = true;
          await this.deleteLookup(item.LookupId);
          Swal.fire({
            title: "Deleted!",
            text: "Lookup has been deleted.",
            confirmButtonText: "OK"
          })
        } catch (error) {
          this.isLoading = false;
          await Swal.fire({
            title: "Error",
            confirmButtonText: "Try Again later"
          })
        } finally {
          this.isLoading = false;
          await this.getTableData();
        }
      }

    },
    labelSort(type, menu) {
      let sort = menu ? type : event.target.textContent.trim()
      this.sortBy = sort
      if (sort == this.sortBy) {
        this.orderAsc = !this.orderAsc
      } else {
        this.orderAsc = true
      }
      switch (sort.toLowerCase()) {
        case "name":
          this.sortData("Name")
          break
        case "value":
          this.sortData("Value")
          break
        case "display value":
          this.sortData("DisplayValue")
          break
        default:
          return null
      }
    },
    sortData(sortValue) {
      const sortedData = this.tableData.sort((a, b) => {
        if (this.orderAsc) {
          return a[sortValue] > b[sortValue] ? 1 : -1
        } else {
          return a[sortValue] < b[sortValue] ? 1 : -1
        }
      })
      this.tableData = sortedData
    }
  }
}
</script>

<style lang="scss" scoped>
#referral {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.md-table {
  max-height: 67dvh;
  overflow: auto;
}

.md-table-cell {
  padding: 2px 8px;
  font-size: 14px;
}

.text-right ::v-deep .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}

.md-table ::v-deep .md-table-head:last-child {
  text-align: left;
}

.table-shopping {
  table > thead > tr > th {
    text-transform: uppercase;
  }

  table > thead > tr > .md-table-head .md-table-head-label {
    font-size: 0.75rem;

    b {
      display: block;
      margin-bottom: 3px;
    }
  }

  .img-container {
    width: 120px;
    max-height: 160px;
    overflow: hidden;
    display: block;

    img {
      width: 100%;
    }
  }
}

.md-table-row:hover {
  background-color: #74b5ff !important;
  color: white;
}

.table-striped {
  tbody > tr:nth-of-type(odd) {
    background-color: #edf2f7;
  }

  tbody > tr:nth-of-type(even) {
    background-color: #ffffff;
  }
}

.modal-header {
  padding-bottom: 16px;
  margin-bottom: 24px;
}

.modal-header h4 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.md-table {
  cursor: pointer;
}

.modal-size {
  max-width: 300px;
  max-height: 400px;
}

</style>
